import React from 'react';
import Title from '../../partials/title';
import ScrollAnimation from 'react-animate-on-scroll';
import _ from 'lodash';

class EntriesGroups extends React.Component {
    render() {
        const { groupings = {} } = this.props;
        return (
            <ScrollAnimation animateIn="fadeInLeft" animateOnce={true} delay={100}>
                { groupings && <Title text={`BOYS`} sub={`(${_.chain(groupings.maleandcoed || []).map(entry => entry.length).reduce((a,b) => a+b, 0).value()})`} className="black margin-top" /> }
                <table className="w3-content font-12 bg-white margin-top w-100" >
                    <thead>
                        <tr className="w3-black small-header-font-768">
                            <th className="p-2">DIVISION</th>
                            <th className="text-left p-2">TEAM</th>
                            <th className="text-left p-2">COACH</th>
                        </tr>
                    </thead>
                    {groupings && groupings.maleandcoed && groupings.maleandcoed.map((entry, i) =>
                        <tbody key={i} className={`${i % 2 ? 'bg-gray' : 'bg-white'} super-small`}>
                            <tr>
                                <td style={{ borderTop: 0, height: 15 }} colSpan="3" className={`${i % 2 ? 'bg-gray' : 'bg-white'}`}></td>
                            </tr>
                            {entry.map((team, index) => (
                                <tr key={index}>
                                    <td style={{ borderTop: 0 }} className=""><i className={`margin-right-half margin-left-half fas fa-${team.TeamIdGender === 2 ? 'female red' : 'male blue'}`} />{team.DivisionName} {team.IsCrossFlight ? <span className="font-8">(CF)</span> : ''}</td>
                                    <td style={{ borderTop: 0 }} className="text-left">{team.TeamName}</td>
                                    <td style={{ borderTop: 0 }} className="text-left">{(_.first(team.roster) || {}).NameLast}</td>
                                </tr>))}
                            <tr>
                                <td style={{ borderTop: 0, height: 15 }} colSpan="3" className={`${i % 2 ? 'bg-gray' : 'bg-white'}`}></td>
                            </tr>
                        </tbody>
                    )}
                </table>

                { groupings && <Title text={`GIRLS`} sub={`(${_.chain(groupings.female || []).map(entry => entry.length).reduce((a,b) => a+b, 0).value()})`} className="black margin-top" /> }
                <table className="w3-content font-12 bg-white margin-top w-100" >
                    <thead>
                        <tr className="w3-black small-header-font-768">
                            <th className="p-2">DIVISION</th>
                            <th className="text-left p-2">TEAM</th>
                            <th className="text-left p-2">COACH</th>
                        </tr>
                    </thead>
                    {groupings && groupings.female && groupings.female.map((entry, i) =>
                        <tbody key={i} className={`${i % 2 ? 'bg-gray' : 'bg-white'} super-small`}>
                            <tr>
                                <td style={{ borderTop: 0, height: 15 }} colSpan="3" className={`${i % 2 ? 'bg-gray' : 'bg-white'}`}></td>
                            </tr>
                            {entry.map((team, index) => (
                                <tr key={index}>
                                    <td style={{ borderTop: 0 }} className=""><i className={`margin-right-half margin-left-half fas fa-${team.TeamIdGender === 2 ? 'female red' : 'male blue'}`} />{team.DivisionName} {team.IsCrossFlight ? <span className="font-8">(CF)</span> : ''}</td>
                                    <td style={{ borderTop: 0 }} className="text-left">{team.TeamName}</td>
                                    <td style={{ borderTop: 0 }} className="text-left">{(_.first(team.roster) || {}).NameLast}</td>
                                </tr>))}
                            <tr>
                                <td style={{ borderTop: 0, height: 15 }} colSpan="3" className={`${i % 2 ? 'bg-gray' : 'bg-white'}`}></td>
                            </tr>
                        </tbody>
                    )}
                </table>
                <span className="p-2 mt-4">(CF = Cross flight)</span>
            </ScrollAnimation>
        )
    }
}

export default EntriesGroups;


// WEBPACK FOOTER //
// ./src/components/tournaments/partials/entries_groups.js